import React, { FC, Suspense } from 'react'
import Box from '@mui/material/Box'
import { CircularProgress } from '@mui/material'

import { SidebarRecentViewButton } from './styled'
import AppPopover from '../../../../../../components/AppPopover'
import { ReactComponent as SearchIcon } from '../../../../../../assets/search.svg'

const SidebarRecentViewBody = React.lazy(
	() =>
		import(
			/* webpackChunkName: "recently_viewed_patients" */ './SidebarRecentViewBody'
		)
)

const recentViewPopoverSx = {
	ml: 4,
	mb: 13,
	'& .MuiPaper-root': {
		overflow: 'hidden',
		display: 'flex',
		flexDirection: 'column',
		width: '27rem',
		py: 7.5,
		borderRadius: '1rem',
	},
}

const SidebarRecentViewPopover: FC = () => {
	return (
		<AppPopover
			renderOpenButton={(onClick, open) => (
				<SidebarRecentViewButton
					aria-label='open recently viewed patients popup'
					onClick={onClick}
					open={open}
				>
					<SearchIcon />
				</SidebarRecentViewButton>
			)}
			popoverProps={{
				anchorOrigin: {
					vertical: 'top',
					horizontal: 'right',
				},
				transformOrigin: {
					vertical: 'center',
					horizontal: 'left',
				},
				marginThreshold: 34,
				sx: recentViewPopoverSx,
			}}
		>
			<Suspense
				fallback={
					<Box
						display={'flex'}
						alignItems={'center'}
						justifyContent={'center'}
						py={64}
					>
						<CircularProgress />
					</Box>
				}
			>
				<SidebarRecentViewBody />
			</Suspense>
		</AppPopover>
	)
}

export default SidebarRecentViewPopover
